export default "__VITE_ASSET__VH5DtnqT__"